module.exports = __webpack_public_path__ + "img/wide.07d94032.svg";